export enum DeployingStatus {
    STARTED = 'STARTED',
    COMPLETED = 'COMPLETED'
}
